import { Stack, Typography } from "@mui/material"
import { Checkbox } from "../Checkbox"
import { useRefinementList } from "react-instantsearch"

interface TypesenseRefineCheckboxProps {
  attribute: string
  values: string[]
  clearFiltersToggle?: boolean
  label: string
  subtitle?: string
}

export const TypesenseRefineCheckbox = ({
  attribute,
  values,
  clearFiltersToggle,
  label,
  subtitle,
}: TypesenseRefineCheckboxProps) => {
  const { items, refine } = useRefinementList({ attribute })

  const isChecked = values.some((value) =>
    items.find((item) => item.value === value && item.isRefined),
  )

  const onChange = (checked: boolean) => {
    values.forEach((value) => refine(value))
  }

  return (
    <Stack flexDirection="row" justifyContent="space-between">
      <Stack>
        <Typography variant="h6">{label}</Typography>
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      </Stack>
      <Checkbox
        disabled={values.length === 0}
        checked={isChecked}
        onChange={onChange}
      />
    </Stack>
  )
}
